<div class="grid-x grid-padding-x">
  <small>{{ 'Portal.Hint.Images' | translate | persianNumber}}</small>
    <div class="small-10 small-offset-1 medium-8 medium-offset-2 cell">
      <h1>{{ 'Portal.Menu.Images' | translate }}</h1>
      <form (change)="share.reloadCurrentRoute()" id="img-upload-form" method="post" enctype="multipart/form-data">
          <div *ngFor="let slider of sliders; let i = index" class="slider-imgs-m">
            <input (change)="upload($event, 'slider', slider.name)" id="{{slider.name}}" class="button ssg-upload-cursor large expanded" type="file" accept="image/*" #inputFile (change)="selectFiles($event)" />
            <span>+</span>
            <img class="preview" width="100px" src="../../../assets/slider/{{slider.name}}.jpg{{DateNow}}" />
          </div>
      </form>
    </div>
  </div>
  <!--
  <label for="exampleFileUpload" class="button">Upload File</label>
  <input type="file" id="exampleFileUpload" class="show-for-sr">
  -->
